import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Activity, TrendingUp, ListOrdered, CalendarDays, Dna,
  Clock4, Crosshair, ShieldAlert, Brain, Tags, GitCompare, Sparkles,
  Gauge, FileText, Trophy, Settings as SettingsIcon,
} from "lucide-react";

export const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/positions", label: "Live Positions", icon: Activity },
  { to: "/performance", label: "Performance", icon: TrendingUp },
  { to: "/trades", label: "Trades", icon: ListOrdered },
  { to: "/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/dna", label: "Trading DNA", icon: Dna },
  { to: "/sessions", label: "Session Analysis", icon: Clock4 },
  { to: "/edge", label: "Edge Finder", icon: Crosshair, soon: true },
  { to: "/risk", label: "Risk Monitor", icon: ShieldAlert },
  { to: "/behavior", label: "Behavior", icon: Brain, soon: true },
  { to: "/setups", label: "Setups", icon: Tags, soon: true },
  { to: "/whatif", label: "What If?", icon: GitCompare, soon: true },
  { to: "/ai", label: "AI Analyst", icon: Sparkles },
  { to: "/score", label: "DELUXE Score", icon: Gauge },
  { to: "/report", label: "Monthly Report", icon: FileText, soon: true },
  { to: "/records", label: "Personal Records", icon: Trophy, soon: true },
  { to: "/settings", label: "Settings", icon: SettingsIcon },
];

export default function Sidebar({ onNavigate }) {
  return (
    <nav className="flex h-full flex-col" data-testid="sidebar-nav">
      <div className="px-6 pb-6 pt-7">
        <img src="/deluxe-logo-main.jpeg" alt="DELUXE" className="w-28" />
        <div className="mt-3 font-sans text-[9px] uppercase tracking-[0.4em] text-zinc-600">
          Trading Analytics
        </div>
      </div>
      <div className="mx-6 h-px dlx-hairline" />
      <div className="dlx-scroll-hide flex-1 space-y-0.5 overflow-y-auto px-3 py-4">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onNavigate}
            data-testid={`nav-${item.to.replace("/", "")}`}
            className={({ isActive }) =>
              `group flex items-center gap-3 rounded-lg px-3 py-2.5 font-sans text-[13px] transition-all duration-200 ${
                isActive
                  ? "bg-gold/10 text-white"
                  : "text-zinc-400 hover:bg-white/[0.03] hover:text-white"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <item.icon size={16} className={isActive ? "text-gold" : "text-zinc-500 group-hover:text-gold"} />
                <span className="flex-1 tracking-wide">{item.label}</span>
                {item.soon && (
                  <span className="rounded-full bg-white/5 px-1.5 py-0.5 font-mono text-[8px] uppercase tracking-wider text-zinc-500">
                    soon
                  </span>
                )}
                {isActive && <span className="h-1 w-1 rounded-full bg-gold" />}
              </>
            )}
          </NavLink>
        ))}
      </div>
      <div className="mx-6 h-px dlx-hairline" />
      <div className="px-6 py-4">
        <div className="font-mono text-[9px] tracking-widest text-zinc-600">
          Niccolò Picco × Diego Leccioli
        </div>
      </div>
    </nav>
  );
}
